// Codici interni di SalesMate -> testo per chi legge.
// Gemello di _MOTIVI in backend/dominio_engine.py: sul link pubblico traduce il server,
// qui traduciamo per lo staff, che altrimenti si vede scritto "password_expired".
const MOTIVI = {
  password_expired: 'Password SalesMate scaduta: va cambiata sul portale TIM, poi aggiornata in Impostazioni › Utenti SSMATE',
  bad_credentials: 'Password SalesMate da aggiornare in Impostazioni › Utenti SSMATE',
  site_down: 'SalesMate non raggiungibile',
  quota_exceeded: 'Quota SalesMate esaurita per oggi',
};

// Un testo non mappato passa invariato: è già discorsivo (es. "Indirizzo non trovato").
export function motivoSalesMate(codice) {
  if (!codice) return '';
  return MOTIVI[codice] || String(codice);
}

// Il guasto è nostro (credenziali), non dell'indirizzo cercato.
export function eCredenziali(codice) {
  return codice === 'password_expired' || codice === 'bad_credentials';
}
